import styled from "styled-components"

export const SpinnerWrapper = styled.div`
  display: grid;
  place-items: center;
  width: 100%;
  aspect-ratio: 16/9;
`